import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const cssModalWrapper = css`
  top: 80px;
  width: 970px;
  height: 550px;
  padding: 24px 16px 0;

  ${({ theme }) => theme.media.mobile} {
    min-width: 100%;
    width: 100%;
    top: 32px;
    border-radius: 0;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const EditWrapper = styled.div`
  display: flex;
  gap: 0 16px;
  align-items: center;
  margin-bottom: 16px;
`;

export const CountSelectedItem = styled.div`
  margin-left: 24px;
  font-size: 14px;

  strong {
    font-weight: bold;
  }
`;

export const Title = styled.h2`
  ${getFontStyle('bold120_B1')}
  color: ${({ theme }) => theme.colors.gray800};
`;

export const NoticeText = styled.p`
  display: flex;
  ${getFontStyle('midium120_C1')}
  color: ${({ theme }) => theme.colors.gray800};

  ${({ theme }) => theme.media.mobile} {
    margin-top: 8px;
  }

  &::before {
    content: '';
    display: block;
    width: 1px;
    height: 16px;
    background-color: ${({ theme }) => theme.colors.gray800};
    margin: 0 12px;

    ${({ theme }) => theme.media.mobile} {
      display: none;
    }
  }
`;

export const Contents = styled.div`
  height: 420px;
  border: 1px solid #ebebeb;
  overflow: auto;
`;

export const TableWrapper = styled.table`
  width: 910px;
  position: relative;
  table-layout: fixed;
`;

export const TableRow = styled.tr`
  cursor: pointer;
`;

export const TableColumn = styled.td`
  padding: 8px 0;
  font-size: 13px;
  text-align: center;
  border-bottom: 1px solid #ddd;
`;

export const TableColumnHeader = styled(TableColumn)`
  height: 56px;
  font-weight: bold;
  border-bottom: 2px solid #ddd;
  vertical-align: middle;
`;

export const SpinnerWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;
